import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';

const url = `${localContentPrefix}/v1/localcontent/products/:productId/republish`;
export const republishLocalContentProduct = (productId: string) => {
    const params = { pathParams: { productId } };

    return http.post(url, {}, params).then(() => Promise.resolve());
};
